var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"marketplace-cell"},[(_vm.data.icon)?_c('span',{staticClass:"marketplace-cell__icon",domProps:{"innerHTML":_vm._s(_vm.data.icon)}}):_vm._e(),_c('span',{staticClass:"marketplace-cell__title"},[_vm._v(_vm._s(_vm.data.title))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }